module.exports = __webpack_public_path__ + "img/claudia-cardinale1.688ab54c.jpg";